import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useEffect, useState } from 'react';

export interface CopyButtonProps {
  /** Testo da copiare negli appunti. */
  value: string;
  /** Cosa si copia, per l'etichetta accessibile («Copia client_id»). */
  label: string;
  size?: 'small' | 'medium';
}

/** Copia un valore negli appunti e conferma per due secondi. */
export function CopyButton({ value, label, size = 'small' }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Tooltip title={copied ? 'Copiato' : `Copia ${label}`}>
      <IconButton aria-label={copied ? `${label} copiato` : `Copia ${label}`} size={size} onClick={() => void copy()}>
        {copied ? <CheckIcon fontSize="inherit" color="success" /> : <ContentCopyIcon fontSize="inherit" />}
      </IconButton>
    </Tooltip>
  );
}
